import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import { Avatar, Box, ButtonBase, Typography } from '@mui/material';
import ProfileMenu from './ProfileMenu';
import { getFullName, getInitials, useSessionUser } from './userInfo';
import { IconChevronDown } from '@tabler/icons';

const ProfileSection = ({ userData: userDataProp }) => {
  const userData = useSessionUser(userDataProp);
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  return (
    <>
      <ButtonBase
        ref={anchorRef}
        onClick={() => setOpen(true)}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Paskyra"
        sx={{
          ml: 1.5,
          height: 44,
          px: 0.75,
          gap: 1,
          borderRadius: '12px',
          border: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
          transition: 'background-color .15s ease',
          '&:hover': { bgcolor: 'action.hover' },
          '&.Mui-focusVisible': { boxShadow: (theme) => `0 0 0 3px ${theme.palette.primary.light}` }
        }}
      >
        <Avatar sx={{ width: 32, height: 32, fontSize: 12, fontWeight: 700 }}>{getInitials(userData)}</Avatar>
        <Box sx={{ display: { xs: 'none', md: 'block' }, maxWidth: 180 }}>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }} noWrap>
            {getFullName(userData)}
          </Typography>
        </Box>
        <Box component="span" sx={{ display: 'flex', color: 'text.disabled', pr: 0.5 }}>
          <IconChevronDown stroke={1.8} size={16} />
        </Box>
      </ButtonBase>

      <ProfileMenu
        anchorEl={anchorRef.current}
        open={open}
        onClose={() => setOpen(false)}
        userData={userData}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ mt: 1 }}
      />
    </>
  );
};

ProfileSection.propTypes = {
  userData: PropTypes.object
};

export default ProfileSection;